import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Capitalize the first letter of a string
 */
export function capitalizeFirstLetter(str: string): string {
  if (!str) return str
  return str.charAt(0).toUpperCase() + str.slice(1)
}

/**
 * Filter option for filter comboboxes
 */
export interface FilterOption {
  key: string
  label: string
  type?: string
  dataType?: string
  isVisible?: boolean
  listContent?: string[]
}
